import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RadiobuttonComponent } from './radiobutton.component';

const routes: Routes = [
  { path: '', component: RadiobuttonComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RadiobuttonRoutingModule { }
